var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTour = function SvgTour(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 3H19c-.55 0-1 .45-1 1v9.5H9.16c-.413 0-.925.094-1.418.246-.492.152-.966.361-1.301.591L.503 18.413c-.336.23-.503.534-.503.837 0 .303.168.606.503.837l5.938 4.076c.335.23.809.439 1.301.591.494.152 1.006.246 1.418.246H18v22c0 .55.45 1 1 1h2.25c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1Zm28.246 10.414L43.56 9.338c-.335-.231-.809-.44-1.302-.592-.493-.152-1.005-.246-1.417-.246H23.75L25.752 20H40.84c.412 0 .924-.094 1.417-.246s.967-.361 1.302-.591l5.938-4.076c.335-.23.503-.533.503-.837 0-.303-.168-.607-.504-.836Z"
  })));
};

export default SvgTour;